import React from 'react';

type IProps = {
  rating: number;
  size: number;
};

export const StarRating = ({ rating, size }: IProps) => {
  const getStarType = (starIndex: number) => {
    if (rating >= starIndex + 1) return 'full';
    if (rating >= starIndex + 0.5) return 'half';
    return 'empty';
  };

  return (
    <div className="flex space-x-0.5">
      {[...Array(5)].map((_, index) => {
        const starType = getStarType(index);
        return (
          <React.Fragment key={index}>
            {starType === 'full' && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={`${size}px`}
                height={`${size}px`}
                viewBox="0 0 32 32"
              >
                <path
                  fill="#F5A623"
                  d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118
  l11.547-1.2L16.026,0.6L20.388,10.918z"
                />
              </svg>
            )}
            {starType === 'half' && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={`${size}px`}
                height={`${size}px`}
                viewBox="0 0 32 32"
              >
                <defs>
                  <linearGradient id="grad">
                    <stop offset="50%" stopColor="#F5A623" />
                    <stop offset="50%" stopColor="#C4C5C8" />
                  </linearGradient>
                </defs>
                <path
                  fill="url(#grad)"
                  d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118
  l11.547-1.2L16.026,0.6L20.388,10.918z"
                />
              </svg>
            )}
            {starType === 'empty' && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={`${size}px`}
                height={`${size}px`}
                viewBox="0 0 32 32"
              >
                <path
                  fill="#C4C5C8"
                  d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118
  l11.547-1.2L16.026,0.6L20.388,10.918z"
                />
              </svg>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
